export const environment = {
  production: false,
  hostUrl: 'https://dev-tceb.vthgdigital.com',
  apiUrl: 'https://dev-tceb.vthgdigital.com/api/',
};
